import { useEffect } from 'react';

interface UseRecordPaymentEffects {
  initTable(): Promise<void>;
  fetchPayments(): Promise<void>;
  fetchAcquiringPaymentMethodNames(): Promise<void>;
  subscribeToAcquiringPaymentUpdateWsEvent: () => () => void;
  initialCardSearchHandler: () => Promise<void>;
}

export const useRecordPaymentEffects = ({
  initTable,
  fetchPayments,
  fetchAcquiringPaymentMethodNames,
  subscribeToAcquiringPaymentUpdateWsEvent,
  initialCardSearchHandler,
}: UseRecordPaymentEffects) => {
  useEffect(() => {
    void initTable();
  }, [initTable]);

  useEffect(() => {
    void fetchPayments();
  }, [fetchPayments]);

  // Способ оплаты по кассам эквайринга зависит от payments, поэтому
  // перезапускается при каждом их изменении (us/11174) — см. fetchPayments.
  useEffect(() => {
    void fetchAcquiringPaymentMethodNames();
  }, [fetchAcquiringPaymentMethodNames]);

  useEffect(() => {
    void initialCardSearchHandler();
  }, [initialCardSearchHandler]);

  // Подписка на WS-события (эквайринг + оплата записи) с корректным отписыванием
  useEffect(() => {
    const unsubscribe = subscribeToAcquiringPaymentUpdateWsEvent();

    return () => {
      unsubscribe?.();
    };
  }, [subscribeToAcquiringPaymentUpdateWsEvent]);
};
